export const MenusData = [
        {
            "areaName": "Dashboard",
            "areaInternalName": "dashboard",
            "pageName": "Dashboard",
            "permissionInternalName": "Dashboard",
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "print": false,
            "email": false
        },
        {
            "areaName": "Masters",
            "areaInternalName": "master",
            "pageName": "Document Type",
            "permissionInternalName": "DocumentType",
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "print": false,
            "email": false
        },
        {
            "areaName": "Operations",
            "areaInternalName": "Operations",
            "pageName": "Work Follow-ups",
            "permissionInternalName": "WorkFollowups",
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "print": true,
            "email": true
        },
        {
            "areaName": "Operations",
            "areaInternalName": "Operations",
            "pageName": "Confirmed Leads",
            "permissionInternalName": "ConfirmedLeads",
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "print": true,
            "email": true
        },
        {
            "areaName": "Configuration",
            "areaInternalName": "Utility",
            "pageName": "Message Template",
            "permissionInternalName": "MessageTemplate",
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "print": false,
            "email": false
        },
        {
            "areaName": "Masters",
            "areaInternalName": "master",
            "pageName": "Customers",
            "permissionInternalName": "Customers",
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "print": false,
            "email": false
        },
        {
            "areaName": "Operations",
            "areaInternalName": "Operations",
            "pageName": "Tasks",
            "permissionInternalName": "Task",
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "print": false,
            "email": false
        },
        {
            "areaName": "Masters",
            "areaInternalName": "master",
            "pageName": "Work Category",
            "permissionInternalName": "WorkCategory",
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "print": false,
            "email": false
        },
        {
            "areaName": "Masters",
            "areaInternalName": "master",
            "pageName": "Payment Mode",
            "permissionInternalName": "PaymentMode",
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "print": false,
            "email": false
        },
        {
            "areaName": "Masters",
            "areaInternalName": "master",
            "pageName": "Company Type",
            "permissionInternalName": "CompanyType",
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "print": false,
            "email": false
        },
        {
            "areaName": "Configuration",
            "areaInternalName": "Utility",
            "pageName": "Users",
            "permissionInternalName": "Users",
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "print": false,
            "email": false
        },
        {
            "areaName": "Configuration",
            "areaInternalName": "Utility",
            "pageName": "Roles & Permissions",
            "permissionInternalName": "RolePermission",
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "print": false,
            "email": false
        },
        {
            "areaName": "Configuration",
            "areaInternalName": "Utility",
            "pageName": "Company Info",
            "permissionInternalName": "Company",
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "print": false,
            "email": false
        },
        {
            "areaName": "Transaction",
            "areaInternalName": "Transaction",
            "pageName": "Ot Hour",
            "permissionInternalName": "othourwise",
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "print": false,
            "email": false
        },
        {
            "areaName": "Transaction",
            "areaInternalName": "Transaction",
            "pageName": "Ot Day",
            "permissionInternalName": "otdaywise",
            "add": true,
            "edit": true,
            "delete": true,
            "view": true,
            "print": false,
            "email": false
        }
    ]